import Flickity from "flickity";

const Logos = (sliderNode) => {
  const children = sliderNode.children;

  // Make clones just in case
  [].forEach.call(children, el => {
    let clone = el.cloneNode(true);
    sliderNode.appendChild(clone);
  });

  const options = {
    accessibility: true,
    resize: true,
    autoplay: false,
    wrapAround: true,
    prevNextButtons: false,
    pageDots: false,
    percentPosition: true
  };

  let flkty = new Flickity(sliderNode, options);
  let requestId = false;
  flkty.x = 0;

  play();

  function play() {
    flkty.x -= 0.6;
    flkty.settle(flkty.x);
    requestId = window.requestAnimationFrame(play);
  }

  function pause() {
    if (requestId) {
      window.cancelAnimationFrame(requestId);
      requestId = undefined;
    }
  }

  sliderNode.addEventListener("mouseenter", () => pause());
  sliderNode.addEventListener("mouseleave", () => play());
};

export default Logos;
